/** @jsxImportSource @emotion/react */
import { ReactComponent as DiscordIcon } from "../../img/discord.svg";
import { ReactComponent as TwitterIcon } from "../../img/twitter.svg";
import { ReactComponent as MediumIcon } from "../../img/about/medium-small.svg";
import { NAV_LINKS } from "../../config/consts";
import styled from "@emotion/styled";
import { Interpolation, Theme, css } from "@emotion/react";

interface SocialLinksProps {
  gap?: string;
  isColored?: boolean;
}

export const SocialIconLinks: React.FC<SocialLinksProps> = ({ gap, isColored = false }) => {
  return (
    <SocialLinksContainer gap={gap}>
      <a href={NAV_LINKS.DISCORD} target="_blank" rel="noreferrer">
        <DiscordIcon css={DiscordIconStyle(isColored)} />
      </a>
      <a href={NAV_LINKS.TWITTER} target="_blank" rel="noreferrer">
        <TwitterIcon css={TwitterIconStyle(isColored)} />
      </a>
      <a href={NAV_LINKS.MEDIUM} target="_blank" rel="noreferrer">
        <MediumIcon css={MediumIconStyle(isColored)} />
      </a>
    </SocialLinksContainer>
  );
};

// Sub-components

interface SocialLinksContainerProps {
  gap?: string;
}

export const SocialLinksContainer = styled.div<SocialLinksContainerProps>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: ${props => (props.gap ? props.gap : "44px")};
  @media (max-width: 300px) {
    transform: scale(80%);
  }
`;

// Helpers

type IconStyle = (isColored: boolean) => Interpolation<Theme>;

export const DiscordIconStyle: IconStyle = isColored => css`
  width: 31px;
  height: 24px;
  color: ${isColored ? "var(--discord-color)" : "inherit"};
  &:hover {
    color: var(--discord-color);
    filter: ${isColored ? "brightness(1.4)" : "none"};
    transition: color 0.3s, filter 0.3s;
  },
`;

export const TwitterIconStyle: IconStyle = isColored => css`
  width: 30px;
  height: 24px;
  color: ${isColored ? "var(--twitter-color)" : "inherit"};
  &:hover {
    color: var(--twitter-color);
    filter: ${isColored ? "brightness(1.4)" : "none"};
    transition: color 0.3s, filter 0.3s;
  },
`;

export const MediumIconStyle: IconStyle = () => css`
  width: 30px;
  height: 24px;
  color: inherit;
  &:hover {
    color: black;
    stroke: #fff;
    strokeWidth: 1px;
    transition: color 0.3s;
  },
`;
